<template>
  <section class="checkout-summary">
    <div class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('rowSumExcludedVatHeader') }}
      </div>
      <div class="checkout-summary__row-price">
        <span class="checkout-summary__row-price">{{ formatPrice(orderSum) }}</span>
      </div>
    </div>

    <div v-if="cart.lineDiscount" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ tStatic('lineDiscount') }}
      </div>
      <div class="checkout-summary__row-price discount">
        {{ formatPrice(-cart.lineDiscount) }}
      </div>
    </div>

    <div class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryPriceOrderLabel') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(0) }}
      </div>
    </div>

    <div v-if="!isOrderRequestVisitorState" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryShippingOrderLabel') }}
      </div>
      <div v-if="showOrdinaryShippingFee" class="checkout-summary__row-price">
        <span class="checkout-summary__row-price-shipping">{{ formatPrice(cart.shippingFee) }}</span>
        <span class="checkout-summary__row-price-ordinary">{{ formatPrice(cart.ordinaryShippingFee) }}</span>
      </div>
      <div v-else class="checkout-summary__row-price">
        <span class="checkout-summary__row-price">{{ formatPrice(cart.shippingFee) }}</span>
      </div>
    </div>

    <div v-if="cart.packagingFee" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryHandlingOrderLabel') }}
      </div>
      <div class="checkout-summary__row-price">
        <span class="checkout-summary__row-price">{{ formatPrice(cart.packagingFee) }}</span>
      </div>
    </div>

    <div v-if="cart.orderDiscount" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ tStatic('orderDiscount') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(-cart.orderDiscount) }}
      </div>
    </div>

    <div class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryVATOrderLabel') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(cart.tax) }}
      </div>
    </div>

    <div class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryTotalOrderLabel') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(cart.totalPrice) }}
      </div>
    </div>

    <div v-if="cart.giftCards && cart.giftCards.length > 0" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryGiftCardTotalAmount') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(giftCardAmount) }}
      </div>
    </div>

    <div v-if="cart.giftCards && cart.giftCards.length > 0" class="checkout-summary__row">
      <div class="checkout-summary__row-description">
        {{ t('summaryTotalAmountToPay') }}
      </div>
      <div class="checkout-summary__row-price">
        {{ formatPrice(cart.totalAmountToPay) }}
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  data: () => ({
    quickAddNumber: ''
  }),
  computed: {
    ...mapGetters('commerce', ['cart']),
    ...mapGetters('checkout', ['isOrderRequestVisitorState']),
    count() {
      return _.chain(this.cart.rows).map(row => row.quantity).sum().value()
    },
    giftCardAmount() {
      return _.chain(this.cart.giftCards)
        .map(row => row.utilized)
        .sum()
        .value()
    },
    showOrdinaryShippingFee() {
      return this.cart.shippingFee !== this.cart.ordinaryShippingFee
    },
    totalPrice() {
      return this.cart.totalPrice + this.cart.shippingFee
    },
    orderSum() {
      return _.chain(this.cart.rows).map(row => row.totalRowCount).sum().value()
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('commerce', ['deleteFromCart'])
  }
}
</script>

<style lang="scss">
.checkout-summary {
  background-color: color(background-light-green);
  border: 5px solid color(border-success-green);
  padding: measure(half);

  @media print {
    break-inside: avoid;
  }

  @include media(small) {
    padding: measure(full);
  }
}

.checkout-summary__row {
  display: flex;
  align-items: center;
  padding: measure(half) 0;
  border-bottom: 1px solid color(green-3);

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  @media print {
    height: 3.125rem;
  }
}

.checkout-summary__row-description {
  @include caption;

  @include media(small) {
    @include body;
  }
}

.checkout-summary__row-price {
  @include caption-semi-bold;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;

  @include media(small) {
    @include body-semi-bold;
  }
}

.checkout-summary__row-price-shipping {
  color: red;
  margin-bottom: measure(quarter);
}

.checkout-summary__row-price-ordinary {
  text-decoration: line-through;
}

.discount {
  color: red;
}
</style>
